import { Directive, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, Renderer2 } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TypedChanges } from '@platform-frontend/util';
import { filter, take, takeLast, takeWhile, tap, timer } from 'rxjs';
import { CountdownTimerValues } from './model/countdown-timer-values';

@UntilDestroy()
@Directive({
  selector: '[yatCountdown]'
})
export class CountdownDirective implements OnChanges {
  constructor(protected element: ElementRef<HTMLButtonElement>, private renderer: Renderer2) {}

  @Input('yatCountdown')
  countdownSeconds: CountdownTimerValues;

  @Output()
  countdownFinished: EventEmitter<void> = new EventEmitter();

  private countdownValue: number | null = null;
  private lastCountdownSeconds: CountdownTimerValues;

  ngOnChanges(changes: TypedChanges<CountdownDirective>): void {
    if (changes.countdownSeconds) {
      this.abortCountdown();
      this.startCountdown();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(): void {
    this.abortCountdown();
  }

  private abortCountdown(): void {
    this.countdownValue = null;
    this.renderer.addClass(this.element.nativeElement, 'countdown-stop');
  }

  private startCountdown(): void {
    if (!this.countdownSeconds) {
      return;
    }

    this.renderer.removeClass(this.element.nativeElement, 'countdown-progress-' + this.lastCountdownSeconds);
    this.renderer.removeClass(this.element.nativeElement, 'countdown-stop');

    this.countdownValue = this.countdownSeconds + 1;
    this.lastCountdownSeconds = this.countdownSeconds;
    this.renderer.addClass(this.element.nativeElement, 'countdown-progress-' + this.countdownSeconds);

    timer(0, 1000)
      .pipe(
        takeWhile(() => this.countdownValue !== null),
        take(this.countdownSeconds + 1),
        tap(() => (this.countdownValue = this.countdownValue !== null ? this.countdownValue - 1 : null)),
        takeLast(1),
        filter(() => this.countdownValue !== null),
        tap(() => this.countdownFinished.emit()),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
